import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { removeJob } from "../redux/features/job/jobSlice";
import thousandSeparator from "../utils/thousandSeparator";

export default function Job({ job }) {
  const dispatch = useDispatch();
  const { id, title, type, salary, deadline } = job || {};
  /* Fulltime - #FF8A00, Internship - #FF5757, Remote - #56E5C4 */

  const handleDelete = () => {
    dispatch(removeJob(id));
  };

  const colorCode =
    type === "Full Time"
      ? "FF8A00"
      : type === "Internship"
      ? "FF5757"
      : type === "Remote"
      ? "56E5C4"
      : "000000";

  return (
    <div className="lws-single-job">
      <div className="flex-1 min-w-0">
        <h2 className="lws-title">{title}</h2>
        <div className="job-footers">
          <div className="lws-type">
            <i
              className={`fa-solid fa-stop !text-[#${colorCode}] text-lg mr-1.5`}
            ></i>
            {type}
          </div>
          <div className="lws-salary">
            <i className="fa-solid fa-bangladeshi-taka-sign text-slate-400 text-lg mr-1.5"></i>
            BDT {thousandSeparator(salary)}
          </div>
          <div className="lws-deadline">
            <i className="fa-regular fa-calendar text-slate-400 text-lg mr-1.5"></i>
            {(new Date(deadline).valueOf() < new Date().valueOf()
              ? "Expired on "
              : "Closing on ") + deadline}
          </div>
        </div>
      </div>
      <div className="mt-5 flex lg:mt-0 lg:ml-4">
        <span className="hidden sm:block">
          <Link
            to={`/editjob/${id}`}
            type="button"
            className="lws-edit btn btn-primary"
          >
            <i className="fa-solid fa-pen text-gray-300 -ml-1 mr-2"></i>
            Edit
          </Link>
        </span>

        <span className="sm:ml-3">
          <button
            type="button"
            className="lws-delete btn btn-danger"
            onClick={handleDelete}
          >
            <i className="fa-solid fa-trash text-gray-300 -ml-1 mr-2"></i>
            Delete
          </button>
        </span>
      </div>
    </div>
  );
}
